import { render, staticRenderFns } from "./WordGroupsForm.vue?vue&type=template&id=23f97a6e&scoped=true"
import script from "./WordGroupsForm.vue?vue&type=script&lang=js"
export * from "./WordGroupsForm.vue?vue&type=script&lang=js"
import style0 from "./WordGroupsForm.vue?vue&type=style&index=0&id=23f97a6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f97a6e",
  null
  
)

export default component.exports